<div class="grow-home-container">
    <div class="header-container" [class.grow]="router.url === '/grow' || router.url.startsWith('/admin/grow-home-preview')">
        <div fxHide fxShow.gt-sm class="grow-search-container" *ngIf="isGrowSearchFeatureEnabled">
            <app-grow-search (searchEvent)="search($event, true)"></app-grow-search>
        </div>

        <!-- Shows Experience Image -->
        <swiper-container
            #swiperElHeader
            init="false"
            class="header-swipper no-pagination"
            [class.visible]="headerBannerContentPreview && !headerBannerContentPreview.content.length"
        >
            <swiper-slide class="slide">
                <div class="slide-image" [style.background-image]="'url(' + headerBannerContentPreview.image.largeUrl + ')'"></div>
                <div class="layer"></div>
                <div class="header-text-container">
                    <h2 tabindex="0" [innerHtml]="headerBannerContentPreview.title | translate"></h2>
                    <div class="header-text" [innerHtml]="headerBannerContentPreview.description | translate"></div>
                </div>
            </swiper-slide>
        </swiper-container>

        <!-- Shows Header Banner Postings Image -->
        <div class="header-swipper-container relative">
            <swiper-container
                #swiperElCoursel
                init="false"
                (slideChangeTransitionEnd)="onSlideChangeTransitionEnd()"
                class="header-swipper"
                [class.no-pagination]="!headerBannerContentPreview.carouselView"
                [class.visible]="headerBannerContentPreview && headerBannerContentPreview.content.length"
            >
                <swiper-slide class="slide" *ngFor="let postingResource of headerBannerContentPreview.content">
                    <div class="slide-image" [style.background-image]="'url(' + postingResource.posting.image.largeUrl + ')'"></div>
                    <div class="layer"></div>
                    <div class="header-text-container">
                        <h2 tabindex="0">{{ postingResource.posting.translation.title | translate }}</h2>
                        <div class="header-text" [innerHTML]="postingResource.posting.translation.description | safeHtml"></div>

                        <div fxLayout="row">
                            <app-flat-button
                                [label]="postingResource.posting.postingType.actionButtonTextKey"
                                (onClick)="openPostingUrl(postingResource.id, postingResource.posting)"
                                *ngIf="postingResource.posting.url"
                            ></app-flat-button>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>
        </div>

        <div class="header-bottom-swipper-container" *ngIf="featuredWidget && featuredWidget.content.length">
            <h2 class="mb-20" tabindex="0">{{ featuredWidget.name | translate }}</h2>
            <app-postings-swipper [featuredWidget]="featuredWidget"></app-postings-swipper>
        </div>
    </div>

    <div #navBar [class.grow]="router.url.startsWith('/grow')">
        <div class="navigation-container" *ngIf="experienceConfig && experienceConfig.experiencesWidgets.length">
            <div class="navigation">
                <nav class="pr-88" mat-tab-nav-bar>
                    <ng-container *ngFor="let experienceWidget of experienceConfig.experiencesWidgets">
                        <a
                            fxLayoutAlign="center center"
                            class="pointer"
                            *ngIf="experienceWidget.hasContent"
                            (keyup.enter)="scrollIntoView(experienceWidget.widget.name)"
                            (click)="scrollIntoView(experienceWidget.widget.name)"
                        >
                            {{ experienceWidget.widget.name | translate }}
                        </a>
                    </ng-container>
                </nav>

                <div fxLayout="row" fxLayoutAlign="center center" class="navigation-search-container" [class.expanded]="isExpanded" *ngIf="isGrowSearchFeatureEnabled">
                    <app-grow-search
                        class="navigation-search mx-12"
                        [isExpanded]="isExpanded"
                        [class.expanded]="isExpanded"
                        (searchEvent)="search($event, isExpanded)"
                    ></app-grow-search>
                    <mat-icon class="pointer mr-12" *ngIf="isExpanded" (click)="isExpanded = !isExpanded">close</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <div class="shimmer-container" *ngIf="isLoading && experienceConfig" [style.background]="experienceConfig.backgroundColor">
        <div class="shimmer">
            <div class="shimmer-title max-w-sm animate"></div>
            <div class="shimmer-card animate"></div>
        </div>
    </div>

    <div *ngIf="experienceConfig && !isLoading" [style.background]="experienceConfig.backgroundColor" class="experience-content-config pb-192">
        <ng-container *ngFor="let experienceWidget of experienceConfig.experiencesWidgets; let i = index">
            <ng-container *ngIf="visibleWidgetCount === null || i < visibleWidgetCount">
            <ng-container *ngIf="widgetGroups.get(experienceWidget.id) as widget">
                <!-- Experience Alumni Widget -->
                <div
                    class="widgets-slider-container"
                    *ngIf="
                        widget.type === 'community' &&
                        widget.content &&
                        widget.content.length &&
                        isAlumniWidgetSectionVisible
                    "
                    tabindex="0"
                    id="{{ widget.name }}"
                >
                    <div class="widgets-slider">
                        <div class="title-container">
                            <h2 class="ellipsis-container mr-8" tabindex="0" [style.color]="experienceConfig.textColor">
                                {{ widget.name | translate }}
                            </h2>
                            <div>
                                <button
                                    class="custom-grow-button"
                                    fxHide
                                    fxShow.gt-xs
                                    attr.aria-label="{{ 'USER.BUTTON.UPDATE_INFORMATION' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                                    (click)="goToUpdateMyProfile()"
                                    *ngIf="isCommunityFeatureEnabled"
                                >
                                    <span class="strong" [style.color]="experienceConfig.backgroundColor">{{ 'USER.BUTTON.UPDATE_INFORMATION' | translate }}</span>
                                </button>
                                <button
                                    class="custom-grow-button ml-12"
                                    attr.aria-label="{{ 'GENERAL.LABEL.VIEW_COMMUNITY' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                                    (click)="goToCommunityPage(widget.id)"
                                >
                                    <span class="strong" [style.color]="experienceConfig.backgroundColor">{{ 'GENERAL.BUTTON.VIEW_ALL' | translate }}</span>
                                </button>
                            </div>
                        </div>
                        <app-alumni-swipper [experienceConfig]="experienceConfig" [experienceAlumniWidget]="widget"></app-alumni-swipper>
                        <div fxLayout="row" fxLayoutAlign="center center" fxShow fxHide.gt-xs class="mb-12 px-20">
                            <button
                                class="custom-grow-button"
                                attr.aria-label="{{ 'USER.BUTTON.UPDATE_INFORMATION' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                                (click)="goToUpdateMyProfile()"
                                *ngIf="isCommunityFeatureEnabled"
                            >
                                <span class="strong" [style.color]="experienceConfig.backgroundColor">{{ 'USER.BUTTON.UPDATE_INFORMATION' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Student Widget -->
                <div *ngIf="widget.type === 'student' && widget.content.length">
                    <div class="widgets-slider-container" id="{{ widget.name }}" tabindex="0">
                        <div class="widgets-slider my-student-modules-list">
                            <div class="title-container">
                                <h2 class="ellipsis-container mr-8" tabindex="0" [style.color]="experienceConfig.textColor">
                                    {{ widget.name | translate }}
                                </h2>
                                <button
                                    class="custom-grow-button"
                                    attr.aria-label="{{ 'GENERAL.LABEL.VIEW_MODULES' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                                    (click)="goToAllModulesPage()"
                                >
                                    <span class="strong" [style.color]="experienceConfig.backgroundColor">{{ 'GENERAL.BUTTON.VIEW_ALL' | translate }}</span>
                                </button>
                            </div>
                            <app-my-student-modules-list *ngIf="widget.content && widget.content.length" [moduleUsers]="widget.content">
                            </app-my-student-modules-list>
                        </div>
                    </div>
                </div>

                <!-- Featured Stream -->
                <div *ngIf="widget.type === 'featured_stream' && widget.content.length">
                    <div class="widgets-slider-container" id="{{ widget.name }}" tabindex="0">
                        <div class="widgets-slider">
                            <div class="title-container">
                                <h2 class="ellipsis-container mr-8" tabindex="0" [style.color]="experienceConfig.textColor">{{ widget.name | translate }}</h2>
                            </div>
                            <app-postings-swipper *ngIf="widget.content.length" [featuredWidget]="widget"></app-postings-swipper>
                        </div>
                    </div>
                </div>

                <!-- Custom Featured Stream -->
                <div *ngIf="widget.type === 'custom_featured_stream' && widget.content.length">
                    <div class="widgets-slider-container" id="{{ widget.name }}" tabindex="0">
                        <div class="widgets-slider">
                            <div class="title-container">
                                <h2 class="ellipsis-container mr-8" tabindex="0" [style.color]="experienceConfig.textColor">{{ widget.name | translate }}</h2>
                            </div>
                            <app-postings-swipper *ngIf="widget.content.length && !isPreview" [featuredWidget]="widget"></app-postings-swipper>
                            <div *ngIf="isPreview" class="preview-text">
                                <span class="basic-text">{{ 'ENGAGE.WIDGET.CUSTOM_WIDGET_PREVIEW_MESSAGE' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            </ng-container>
            <div class="shimmer-container" *ngIf="visibleWidgetCount !== null && i === visibleWidgetCount">
                <div class="shimmer">
                    <div class="shimmer-title max-w-sm animate"></div>
                    <div class="shimmer-card animate"></div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
